/** Shared seat-location color palette (12 unique, then repeats by index). */
export const LOCATION_COLOR_PALETTE = [
  '#25617ee3',
  'rgb(116 126 37 / 89%)',
  'rgb(126 37 37 / 89%)',
  'rgb(90 90 90 / 89%)',
  'rgb(37 90 126 / 89%)',
  'rgb(126 90 37 / 89%)',
  'rgb(90 37 126 / 89%)',
  'rgb(37 126 90 / 89%)',
  'rgb(126 37 90 / 89%)',
  'rgb(37 126 126 / 89%)',
  'rgb(126 110 37 / 89%)',
  'rgb(70 70 140 / 89%)',
];

/**
 * Resolve background color for a seat location.
 * Prefer a saved setting; otherwise use palette index (unique for first 12, then repeats).
 */
export function colorForLocation(seatLocation, seatLocations = [], locationColors = {}) {
  const key = String(seatLocation || '').trim();
  if (key && locationColors && typeof locationColors === 'object' && locationColors[key]) {
    return { backgroundColor: locationColors[key] };
  }
  const index = seatLocations.indexOf(key);
  const paletteIndex = index >= 0 ? index % LOCATION_COLOR_PALETTE.length : 0;
  return { backgroundColor: LOCATION_COLOR_PALETTE[paletteIndex] };
}

/** Unique trimmed seatLocation values from a seats list, sorted A→Z. */
export function uniqueSeatLocations(seats) {
  return [...new Set(
    (Array.isArray(seats) ? seats : [])
      .map((seat) => (seat.seatLocation != null ? String(seat.seatLocation).trim() : ''))
      .filter(Boolean)
  )].sort((a, b) => a.localeCompare(b));
}
